// extracted by mini-css-extract-plugin
module.exports = {"main":"Modal_main__1lKh0"};